import { photosShow } from '../../../helpers/photosShow';
import { fileuploadDir } from '../../../config';

// Display helpers of the owner reporting pages. They only FORMAT what the server returns (no amount is computed here).

export const DASH = '—';

export function formatMoney(amount, currency, locale) {
  if (amount === null || amount === undefined || Number.isNaN(Number(amount))) return DASH;
  const value = Number(amount);
  const digits = Number.isInteger(value) ? 0 : 2;
  try {
    return new Intl.NumberFormat(locale || 'en', {
      style: 'currency', currency, minimumFractionDigits: digits, maximumFractionDigits: digits,
    }).format(value);
  } catch (error) {
    return currency ? `${value} ${currency}` : String(value);
  }
}

export function formatCount(value, locale) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return DASH;
  try { return new Intl.NumberFormat(locale || 'en').format(Number(value)); } catch (error) { return String(value); }
}

// Percentage already computed by the server (variation). Keeps the sign, one decimal at most.
export function formatPercent(value, locale) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return DASH;
  const number = Number(value);
  try {
    const text = new Intl.NumberFormat(locale || 'en', { maximumFractionDigits: 1 }).format(Math.abs(number));
    return `${number > 0 ? '+' : number < 0 ? '-' : ''}${text} %`;
  } catch (error) {
    return `${number} %`;
  }
}

// A rate already computed by the server (occupancy, in %), without sign: 52.2 -> "52,2 %". Display only.
export function formatRate(value, locale) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return DASH;
  try { return `${new Intl.NumberFormat(locale || 'en', { maximumFractionDigits: 1 }).format(Number(value))} %`; } catch (error) { return `${value} %`; }
}

// 'YYYY-MM-DD' (server calendar day) -> localized text, always read in UTC so the day never shifts with the browser time zone.
const FORMATS = {
  short: { day: 'numeric', month: 'short', timeZone: 'UTC' },
  medium: { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' },
  month: { month: 'short', timeZone: 'UTC' },
  monthYear: { month: 'short', year: 'numeric', timeZone: 'UTC' },
  year: { year: 'numeric', timeZone: 'UTC' },
};
export function formatDay(day, locale, style = 'medium') {
  if (!day || !/^\d{4}-\d{2}-\d{2}/.test(String(day))) return DASH;
  const date = new Date(`${String(day).slice(0, 10)}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return DASH;
  try { return new Intl.DateTimeFormat(locale || 'en', FORMATS[style] || FORMATS.medium).format(date); } catch (error) { return String(day); }
}

// Label of a chart point from its first day and the granularity.
export function formatSeriesLabel(point, granularity, locale, { withYear = false } = {}) {
  if (!point || !point.start) return '';
  if (granularity === 'year') return formatDay(point.start, locale, 'year');
  if (granularity === 'month') return formatDay(point.start, locale, withYear ? 'monthYear' : 'month');
  return formatDay(point.start, locale, withYear ? 'medium' : 'short');
}

export function photoUrl(photo) {
  if (!photo) return null;
  // encoded: the name goes inside url("...") (quotes, parentheses and spaces must not break out of it)
  const safe = encodeURIComponent(String(photo)).replace(/[()']/g, (char) => `%${char.charCodeAt(0).toString(16).toUpperCase()}`);
  return `${photosShow(fileuploadDir) || ''}x_small_${safe}`;
}
